// extracted by mini-css-extract-plugin
export default {"backdrop":"Spinner_backdrop__uhy0f"};